import { taxOfficeList } from "./taxOfficeList";

export const taxOfficeSelectOptions = taxOfficeList.map((taxOffice) => ({
  value: taxOffice,
  label: taxOffice
}));
